import { Button, useDisclosure } from "@chakra-ui/react";
import { RiAddCircleLine } from "react-icons/ri";
import { AddStudentsDialog } from "./AddStudentsDialog";
import { ParentAddress } from "./useAddStudentsToParent";

interface AddStudentsButtonProps {
  organizationId: string;
  parentId: string;
  parentName: string;
  parentAddress: ParentAddress;
  excludeIds: string[];
}

export function AddStudentsButton({
  organizationId,
  parentId,
  parentName,
  parentAddress,
  excludeIds,
}: AddStudentsButtonProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        aria-label="Add student"
        leftIcon={<RiAddCircleLine />}
        variant="outline"
        colorScheme="gray"
        onClick={onOpen}
      >
        Add student
      </Button>
      {/* Remount per open so staged entries reset. */}
      <AddStudentsDialog
        key={isOpen ? "open" : "closed"}
        isOpen={isOpen}
        onClose={onClose}
        organizationId={organizationId}
        parentId={parentId}
        parentName={parentName}
        parentAddress={parentAddress}
        excludeIds={excludeIds}
      />
    </>
  );
}
